"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var StyledTable_1 = require("../Table/StyledTable");
var TableContext_1 = require("../Table/TableContext");
var TableBody = function (props) { return (react_1.default.createElement(TableContext_1.TableContext.Provider, { value: "body" },
    react_1.default.createElement(StyledTable_1.StyledTableBody, tslib_1.__assign({}, props)))); };
exports.TableBody = TableBody;
//# sourceMappingURL=TableBody.js.map